import { Machine } from 'xstate'

const findMachineDef = (machine, path) => {
  const currentPath = path.shift()
  const stateDef = machine.states[currentPath]
  if (stateDef === undefined) return console.warn('Could not find a definition with the provided path.')
  else if (path.length > 0) return findMachineDef(stateDef, path)
  else return stateDef
}
const runOnEntry = (machine, currentStateName) => {
  const path = currentStateName.split('.')
  const def = findMachineDef(machine, path)
  if (def && Array.isArray(def.onEntry)) {
    def.onEntry.reduce(async (state, action) => {
      await action()
    }, undefined)
  }
}
const initTransition = (machine, initState) => {
  let newState = machine.transition(initState, '')
  return newState
}
function setup (machine) {
  return function (state, runOnEntryActions = true) {
    if (state) {
      machine = Object.assign({}, machine, {initial: state})
    }
    if (machine === undefined) {
      console.warn('Machine is undefined, and cannot initialize properly.')
      return
    } else this.machine = new Machine(machine)
    this.state = initTransition(this.machine, machine.initial)
    if (runOnEntryActions) runOnEntry(machine, this.currentStateName())
  }
}

export default class BaseStateMachine {
  constructor (machineDefinition) {
    // if (new.target === BaseStateMachine) {
    //   throw new TypeError('Cannot construct BaseStateMachine directly since its intention is to be abstract')
    // }
    this.machine = null
    this.initState = setup(machineDefinition)
    this.state = null
  }
  currentStateName (currentState) {
    if (this.state === null) return
    const state = currentState || this.state.value
    if (typeof state === 'object') {
      const key = Object.keys(state)[0]
      return `${key}.${this.currentStateName(state[key])}`
    } else {
      return state
    }
  }
  async command (action, state, args) {
    if (action.constructor.name === 'Function' || action.constructor.name === 'AsyncFunction') {
      await action(state, ...args)
    } else {
      await this[action](state, ...args)
    }
  }
  async transition (event, ...args) {
    if (this.machine === null) return
    const state = this.machine.transition(this.state, event)
    this.state = state
    const stateArgs = { currentStateName: this.currentStateName(), state }
    for (const action of state.actions) {
      await this.command(action, stateArgs, args)
    }
    return state
  }
}
